import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class FIConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Fi
  static abbreviation = 'fi'
  static label = 'Force Index'
  static shortLabel = 'FORCE'
  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['fi']
  static calculatedValuesLabels = { fi: 'Force Index' }
}
